export default __webpack_public_path__ + "static/media/hour-glass.be7b6841.svg";